import { AssistantAuditAction } from '../log';
import { Practice } from '../practice';
import { Language } from '../previsit/language';
import { UserWithProfileAndPreference } from '../user';

export enum SourceComponent {
  Hero = 'HERO',
}

export interface ChatHistory {
  content: string;
  example: boolean;
}

export interface SourceDocument {
  metadata: {
    title: string;
    url: string;
    allowExternal: boolean;
    _additional: {
      id: string;
    };
  };
  page_content: string;
}

export enum Recommendation {
  Authentication = 'AUTHENTICATION',
  None = 'NONE',
  Scheduling = 'SCHEDULING',
  ViewOrPayBill = 'VIEW_OR_PAY_BILL',
}

export interface ResponseEntities {
  address?: string;
  phone_number?: string;
  staticMap?: string;
  latitude?: string;
  longitude?: string;
  recommendation?: Recommendation;
}

export enum Intent {
  AuthorizationStatus = 'authorization_status',
  EmergencyOrUrgentCare = 'emergency_or_urgent_care',
  FinancialAssistance = 'financial_assistance',
  GeneralInformation = 'general_information',
  Payment = 'payment',
  PrescriptionRefill = 'prescription_refill',
  ProviderBrowse = 'provider_browse',
  ProviderScheduling = 'provider_scheduling',
  ProviderSearch = 'provider_search',
  Rescheduling = 'rescheduling',
  TestResults = 'test_results',
  Scheduling = 'scheduling',
  BasicChat = 'basic_chat',
}

export enum IntentComponent {
  GeneralInformationAppointmentConfirmed = 'GENERAL_INFORMATION_APPOINTMENT_CONFIRMED',
  MedicationRefillAppointmentConfirmed = 'MEDICATION_REFILL_APPOINTMENT_CONFIRMED',
  PaymentSelectMethod = 'PAYMENT_SELECT_METHOD',
  PaymentConfirmed = 'PAYMENT_CONFIRMED',
  ReschedulingAppointmentActionConfirmed = 'RESCHEDULING_APPOINTMENT_ACTION_CONFIRMED',
  ReschedulingAppointmentCancelling = 'RESCHEDULING_APPOINTMENT_CANCELLING',
  ReschedulingAppointmentList = 'RESCHEDULING_APPOINTMENT_LIST',
  ReschedulingAppointmentRescheduling = 'RESCHEDULING_APPOINTMENT_RESCHEDULING',
}

export enum MessageError {
  Timeout = 'TIMEOUT',
}

export interface ChatResponse {
  chat_message_id: string;
  answer: string;
  source_documents: SourceDocument[];
  response_entities: ResponseEntities;
  intent: Intent | string;
  recommendedProviders?: (
    | UserWithProfileAndPreference
    | Pick<UserWithProfileAndPreference, 'id'>
  )[];
  hacks?: { providers?: UserWithProfileAndPreference[] };
  user_entities: {
    user_first_name?: string;
    user_last_name?: string;
    user_email?: string;
    user_phone_number?: string;
    user_dob?: string;
  };
  intentComponent?: IntentComponent;
  done: boolean;
  error?: MessageError;
}

export enum Modality {
  Hero = 'HERO',
  HeroCompact = 'HERO_COMPACT',
  Input = 'INPUT',
  TakeoverButton = 'TAKEOVER_BUTTON',
}

export interface ProviderFilters {
  supportedPractices: Pick<Practice, 'id' | 'name'>[];
  supportedLanguages: Language[];
}

interface AssistantAuditLogBase {
  action: AssistantAuditAction;
  assistantId: string;
}

interface AssistantAuditLogBaseWithSession extends AssistantAuditLogBase {
  sessionId: string;
}

export interface AssistantPatientClickedProviderParams
  extends AssistantAuditLogBase {
  action:
    | AssistantAuditAction.AssistantPatientClickedProviderPhoneNumber
    | AssistantAuditAction.AssistantPatientClickedProviderProfile;
  providerUserId: string;
  sessionId: string;
}

export interface AssistantPatientClickedSourceDocumentParams
  extends AssistantAuditLogBaseWithSession {
  action: AssistantAuditAction.AssistantPatientClickedSourceDocument;
  messageId: string;
  documentId: string;
}

export interface AssistantPatientClickedStaticMapParams
  extends AssistantAuditLogBaseWithSession {
  action: AssistantAuditAction.AssistantPatientClickedStaticMap;
  messageId: string;
}

export interface AssistantVisibleParams
  extends AssistantAuditLogBaseWithSession {
  action: AssistantAuditAction.AssistantVisible;
}

export type AssistantReqAuditParams =
  | AssistantPatientClickedProviderParams
  | AssistantPatientClickedSourceDocumentParams
  | AssistantPatientClickedStaticMapParams
  | AssistantVisibleParams;
